import { formatBooleanValue } from "../../util";
import RegistryInstitution from "../model/RegistryInstitution";

const RegistryInstitutionMapper = (item: any) => {
  let registryInstitution = RegistryInstitution(item);
  registryInstitution.code = item.sifra;
  registryInstitution.name = item.naziv;
  registryInstitution.description = item.opis;
  registryInstitution.valid = formatBooleanValue(item.vazi);
  return registryInstitution;
};

export default RegistryInstitutionMapper;
